<div class="container my-5">
    <div class="card shadow-sm border-0 rounded-4 p-5 text-center">
        <!-- Lista de pasos -->
        <h4 class="wrapper__form__title h3-tipografia-govco mb-0">
            <i class="fa fa fa-sign-out"></i>
            {{ 'pasos-seguir.titulo' | translate }}
        </h4>
        <h6 class="wrapper__form__title h3-tipografia-govco my-1">
            {{ 'pasos-seguir.pregunta' | translate }}</h6>
        <div class="steps-list mx-auto" style="max-width: 500px;" *ngIf="textoPasosCreacionEmpresa">
            <div class="step-item bg-light p-3 rounded-3 mb-3 d-flex">
                <div class="step-number bg-primary text-white rounded-circle flex-shrink-0">
                    1
                </div>
                <div class="step-text">
                    <p class="mb-0">
                        {{textoPasosCreacionEmpresa.data.registros[0].valor_parametro}}
                    </p>
                </div>
            </div>

            <div class="step-item bg-light p-3 rounded-3 mb-3 d-flex">
                <div class="step-number bg-primary text-white rounded-circle flex-shrink-0">
                    2
                </div>
                <div class="step-text">
                    <p class="mb-0">
                        {{textoPasosCreacionEmpresa.data.registros[1].valor_parametro}}
                    </p>
                </div>
            </div>
        </div>

    </div>
  <!-- Se comenta el correo, de acuerdo con el bug # 5765-->
    <!-- Footer -->
<!--    <div class="mt-4 text-muted small text-center">-->
<!--        <i class="bi bi-envelope"></i> {{ 'autenticacion-digital.correoAyuda' | translate }}-->
<!--    </div>-->
</div>
